import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {GoogleTagManagerService} from 'angular-google-tag-manager';
import { DataService } from '../../data.service';
import { Gallery, GalleryRef } from '@ngx-gallery/core';
import { Lightbox } from '@ngx-gallery/lightbox';
import { DownloadsService } from 'src/app/business/download/downloads.service';
import {environment} from "../../../environments/environment";

@Component({
  selector: 'app-article-box',
  templateUrl: './article-box.component.html',
  styleUrls: ['./article-box.component.scss'],
  // encapsulation: ViewEncapsulation.None
})
export class ArticleBoxComponent {



  @Input() sendStats = false;
  @Output() onSelectTag = new EventEmitter<any>(null);
  @Input() index;
  @Output() onClickItem = new EventEmitter<any>(null);
  @Input() showEntry = true;

  @Input() link = '.';

  _article = {
    tags: [],

    image: null,
    title: null,
    slug: null,
    short_content: null,
    class: null,
    link: null,
    category: null,
    pagelink: null,
    image_list_xs: null,
    image_list_sm: null,
    image_list_md: null,
    image_list_lg: null,
    image_alt: null
  };

  constructor(
    private downloadsService: DownloadsService,
    private gallery: Gallery,
    public lightbox: Lightbox,
    private gtmService: GoogleTagManagerService
  ) {}

  get article() {
    return this._article;
  }

  @Input()
  set article(article) {
    this._article = article;
  }

  @Input() type;

  itemClick() {
    this.onClickItem.emit(this.index);
  }

  selectTag(tag) {
    this.onSelectTag.emit(tag);
  }

  getImages(images) {
    let string = '';
    images.forEach((image, index) => {
      string += `${image[0]} ${image[1]}`;
      if (index !== (images.length -1)) {
        string += ', ';
      }
    });
    return string;
  }

  sendStat(url) {
    if (this.sendStats) {
      const gtmTag = {
        event: 'uaevent',
        eventCategory: 'Homepage',
        eventAction: 'Articles',
        pageName: url
      };
      if (environment.ga) {
        this.gtmService.pushTag(gtmTag);
      }
    }
  }

  isVideo(file) {
    if (file) {
      return file.mime_type.indexOf('video/') === 0;
    }
    return false;
  }

  openVideo(file) {
    const galleryRef: GalleryRef = this.gallery.ref(file.id);
    galleryRef.reset();
    galleryRef.addVideo({
      src: file.file_path,
    });
    this.lightbox.open(0, file.id);
  }

  // getType(url) {
  //   const mime = require('mime');
  //   const ext = url.substr(url.lastIndexOf('.') + 1);
  //   const data = {
  //     ext: ext,
  //     type: mime.getType(ext)
  //   };
  //   return data;
  // }

  getFile(fil) {
    this.downloadsService.newDownload(`/platform/content/${fil.id}/download-file`, this._article.title, fil.name);
  }

}
